import type { SettingsTabId } from '../../../store/proxy-store';

type ProxySettingsNavEntry = {
  value: SettingsTabId;
  labelKey: string;
};

export const PROXY_SETTINGS_DEFAULT_SECTION: SettingsTabId = 'general';

export const LEGACY_INTERNAL_NETWORK_TUNNEL_SECTION =
  'internal-network-tunnel' as const;

export const PROXY_SETTINGS_NAV_ENTRIES: readonly ProxySettingsNavEntry[] = [
  { value: 'general', labelKey: 'general' },
  { value: 'upstream', labelKey: 'upstream' },
  { value: 'headers', labelKey: 'headers' },
  { value: 'security', labelKey: 'security' },
  {
    value: 'client-tls-certificates',
    labelKey: 'clientTlsCertificates',
  },
  { value: 'browser', labelKey: 'browser' },
  { value: 'shortcuts', labelKey: 'shortcuts' },
  { value: 'mcp-servers', labelKey: 'mcpServers' },
];

export type ProxySettingsNavVisibility = {
  isMcpServersEnabled: boolean;
};

const isSectionVisible = ({
  section,
  visibility,
}: {
  section: SettingsTabId;
  visibility: ProxySettingsNavVisibility;
}): boolean =>
  section === 'mcp-servers' ? visibility.isMcpServersEnabled : true;

export const getVisibleProxySettingsNavEntries = (
  visibility: ProxySettingsNavVisibility,
): ProxySettingsNavEntry[] =>
  PROXY_SETTINGS_NAV_ENTRIES.filter((entry) =>
    isSectionVisible({ section: entry.value, visibility }),
  );

export const resolveVisibleProxySettingsSection = ({
  activeSection,
  visibility,
}: {
  activeSection: SettingsTabId | typeof LEGACY_INTERNAL_NETWORK_TUNNEL_SECTION;
  visibility: ProxySettingsNavVisibility;
}): SettingsTabId => {
  if (activeSection === LEGACY_INTERNAL_NETWORK_TUNNEL_SECTION) {
    return 'upstream';
  }

  const isKnownSection = PROXY_SETTINGS_NAV_ENTRIES.some(
    (entry) => entry.value === activeSection,
  );

  return isKnownSection &&
    isSectionVisible({ section: activeSection, visibility })
    ? activeSection
    : PROXY_SETTINGS_DEFAULT_SECTION;
};
